import React, { useState, useEffect } from "react";
import { Card, Grid, Sticky, Button, Icon, Modal, Dimmer, Loader } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Events.css";
import "../css/RSO.css";

export default function RSO() {
    const [eventList, setEventList] = useState([]);
    const [approveEvent, setApproveEvent] = useState([]);
    const [updateCheck, setUpdateCheck] = useState(0);
    const [errorMessage, setErrorMessage] = useState();
    const [errorDisplay, setErrorDisplay] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        // setEventList([{ key: 1 }, { key: 2 }, { key: 3 }]);
        // setApproveEvent([{ key: 2 }]);
        // console.log(
        //     "T.O.P. check: " +
        //         approveEvent.some((approval) => approval.key === 2)
        // );
        // global.uniid = 14;
        // global.userid = 104;
        console.log(localStorage.getItem("uniid"));
        handleGetRSO();
        handleRSOJoined();
        console.log("all rso");
        console.log(eventList);
        console.log("joined rso");
        console.log(approveEvent);
    }, []);

    useEffect(() => {
        handleGetRSO();
        handleRSOJoined();
    }, [updateCheck]);

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectMyRSO = () => {
        if (localStorage.getItem("adminorsuper") == 0)
            navigate("/MyRSOs");
        else
            navigate("/ApproveRSOs");
    };

    const redirectMyEvent = () => {
        navigate("/ApproveEvents");
    };

    const redirectEvent = () => {
        navigate("/Events");
    };

    // useEffect(() => {
    //     console.log("listy");
    //     console.log(eventList);
    //     console.log("approovy");
    //     console.log(approveEvent);
    // }, [eventList, approveEvent]);

    async function handleRSOJoined() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listJoinedRSOs.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setApproveEvent(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleGetRSO() {
        try {
            let info = {
                uniid: localStorage.getItem("uniid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listRSOs.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error for listRSO: " + res.error);

            if (res.error === "") {
                setEventList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleLeave = (event) => (e) => {
        handleLeaveHelper(event);
    };

    async function handleLeaveHelper(event) {
        try {
            let info = {
                rsoid: event.rsoid,
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/leaveRSO.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                // alert(res.error);
                setErrorDisplay(true);
                setErrorMessage(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleJoin = (event) => (e) => {
        handleJoinHelper(event);
    };

    async function handleJoinHelper(event) {
        try {
            let info = {
                rsoid: event.rsoid,
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/joinRSO.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                // alert(res.error);
                setErrorDisplay(true);
                setErrorMessage(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row">
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem("first")}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectMyRSO}>{(localStorage.getItem("adminorsuper") == 0) ? ("My RSOs") : ("Approve RSOs")}</p>
                    <p className="events-subpage-link" onClick={redirectMyEvent}>{(localStorage.getItem("adminorsuper") == 0) ? ("") : ("Approve Events")}</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        {(localStorage.getItem("adminorsuper") == 0) ? 
                            (<Icon className="event-icon" name='sign-out' size='large' />) :
                            (<Icon className="event-icon2" name='sign-out' size='large' />)}
                    </Button>
                </div>
                <div className="events-right-container column thirteen wide">
                    <h2 className="events-title">
                        Registered Student Organizations
                    </h2>
                    <div className="events-event-cards-container">
                        {(eventList.length!==0) ? (
                        eventList.map((event) => (
                            <div className="RSO-card-container">
                                {!eventList.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={3}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        {(localStorage.getItem("adminorsuper") == 0) ? (
                                        <Grid.Column>
                                            {!approveEvent.some(
                                                (approvedEvent) =>
                                                    approvedEvent.rsoid ===
                                                    event.rsoid
                                            ) ? (
                                                <Button
                                                    color="blue"
                                                    size="massive"
                                                    className="RSO-join-button"
                                                    onClick={handleJoin(event)}
                                                >
                                                    JOIN RSO
                                                </Button>
                                            ) : (
                                                <Button
                                                    color="red"
                                                    size="massive"
                                                    className="RSO-leave-button"
                                                    onClick={handleLeave(event)}
                                                >
                                                    LEAVE RSO
                                                </Button>
                                            )}
                                        </Grid.Column>) : (<Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Total Members:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                <b>{event.no_students}</b>
                                            </p>
                                        </Grid.Column>)}
                                    </Grid>
                                </Card>
                                ) : (<h3>No RSOs Available</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                </div>
                <Modal open={errorDisplay}>
                    <Modal.Header>Error</Modal.Header>    
                    <Modal.Content>
                        <Modal.Description>
                            <p>{errorMessage}</p>
                        </Modal.Description>         
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="black" onClick={() => setErrorDisplay(false)}>
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        </div>
    );
}
